@if (visible$ | async) {
  <div class="backdrop" [class.backdrop--scoped]="scoped">
    <div
      class="loading-spinner"
    [style.border-top]="
      '4px solid ' + (whiteLabelInfo ? whiteLabelInfo.brandColor : '#ed1c25')
    "
      #loader
    ></div>
  </div>
}
